import { create } from "zustand";
import { persist } from "zustand/middleware";

type RunChangesDiffToggleStore = {
  isNewDiffEnabled: boolean;
  setIsNewDiffEnabled: (isNewDiffEnabled: boolean) => void;
};

export const useRunChangesDiffToggleStore = create<RunChangesDiffToggleStore>()(
  persist(
    (set) => ({
      isNewDiffEnabled: true,
      setIsNewDiffEnabled: (isNewDiffEnabled) => set({ isNewDiffEnabled }),
    }),
    {
      name: "run-changes-diff-toggle",
      partialize: (state) => ({
        isNewDiffEnabled: state.isNewDiffEnabled,
      }),
    }
  )
);
